import React, { Fragment, useState } from "react";
import Breadcrumb from "../../common/breadcrumb";
import MenuItem from "@mui/material/MenuItem";
import { Card, CardBody, Container, Row } from "reactstrap";

import { Button } from "@mui/material";
import { Grid, TextField } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";

import { PersonSearch, Add, Refresh, Download, Report, FileCopy } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import CommonAccordion from "../../common/commonAccordion";
// import CommonTable from "../../common/commonTable";
import {
  vendorRegistrationListTableData,
  vendorRegistrationListTableHeader,
} from "../../common/commonConstantAp";
import { useEffect } from "react";
import {
  getAllVendorRegistrationList,
  exportToExcelVendorRegistration,
  searchVendorRegistrationListData,
  exportToExcelVendorRegistrationSAP,
} from "../../api/ap_services";
import CommonLoader from "../../common/commonLoader";
import { useNavigate } from "react-router-dom";
import CommonTableAp from "../../common/commonTableAp";
import moment from "moment";
import { useVendorCode } from "../../context/VendorCodeProvider";


const useStyles = makeStyles((theme) => ({
  btnClass: {
    padding: "0.5rem 1.5rem!important",
    fontWeight: 600,
  },

  btnJust: {
    display: "flex!important",
    justifyContent: "end!important",
  },

  cardbody: {
    padding: `${theme.spacing(1.8, 1.3)} !important`,
    [theme.breakpoints.down("sm")]: {
      padding: `${theme.spacing(0)} !important`,
      margin: `${theme.spacing(0, 1)} !important`,
    },
  },

  muiGrid: {
    marginTop: "-2vh",
    [theme.breakpoints.down("sm")]: {
      lineHeight: 5,
    },
  },
}));

const VendorRegistrationList = () => {
  const history = useNavigate();
  const classes = useStyles();
  const [totalRecord, setTotalRecord] = React.useState(0);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const initialValues = {
    vendorRegistrationListId: null,
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [vendorTypeCodeMap, setVendorTypeCodeMap] = useState({});
  const [vendorOptions, setVendorOptions] = useState([]);
  const { selectedVendorCode, selectedVendorName } = useVendorCode();
  
  const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const groupId = userData?.groupId ?? userData?.group_id;
  const isSAPAdmin = Number(groupId) === 21;

  useEffect(() => {
    getAllVendorRegistrationList(0, 9999).then((res) => {
      const list = res?.response?.responseObject ?? [];
      const options = Array.isArray(list)
        ? list.map((item) => ({
            vendorCode: item.vendorCode ?? item.vendor_code ?? "",
            vendorName: item.companyName ?? item.company_name ?? "",
          }))
        : [];
      setVendorOptions(options);
    });
  }, []);

  const normalizeListRow = (item) => {
    const vendorCode = item.vendor_code ?? item.vendorCode ?? "";
    const vendorTypeId = item.vendorTypeId ?? item.vendor_type_id;
    const resolvedCode =
      vendorCode !== ""
        ? vendorCode
        : vendorTypeId != null && vendorTypeId !== ""
          ? (vendorTypeCodeMap[String(vendorTypeId)] ?? "")
          : "";
    return { ...item, vendorCode: resolvedCode };
  };

  const filterInitialValues = {
    searchName: "",
    searchVendorCode: "",
    searchRegNo: "",
  };
  const [searchData, setSearchData] = useState(filterInitialValues);

  const onFilterInputChange = (event) => {
    const { name, value } = event.target;
    setSearchData((prev) => ({ ...prev, [name]: value }));
  };

  const companyNameOptions = React.useMemo(() => {
    const seen = new Set();
    return vendorOptions.filter((opt) => {
      const name = opt.vendorName || "";
      if (seen.has(name)) return false;
      seen.add(name);
      return true;
    });
  }, [vendorOptions]);

  useEffect(() => {
    loadListData();
  }, []);

  // useEffect(() => {
  //   if (data.length > 0 && Object.keys(vendorTypeCodeMap).length > 0) {
  //     setData((prev) => prev.map(normalizeListRow));
  //   }
  // }, [vendorTypeCodeMap]);

  const loadListData = () => {
    setLoading(true);
    getAllVendorRegistrationList(page, rowsPerPage).then((res) => {
      setLoading(false);
      const raw = res.response.responseObject ?? [];
      setData(Array.isArray(raw) ? raw.map(normalizeListRow) : []);
      setTotalRecord(res.response.responseMap?.totalCount ?? 0);
    });
  };

  const redirectToVendorRegistrationForm = (data = initialValues) => {
    history(
      `${process.env.PUBLIC_URL}/master/vendorRegistrationForm/${data.vendorRegistrationListId}`,
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllVendorRegistrationList(newPage, rowsPerPage).then((res) => {
      const raw = res.response.responseObject ?? [];
      setData(Array.isArray(raw) ? raw.map(normalizeListRow) : []);
      setTotalRecord(res.response.responseMap?.totalCount ?? 0);
    });
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
    getAllVendorRegistrationList(0, event.target.value).then((res) => {
      const raw = res.response.responseObject ?? [];
      setData(Array.isArray(raw) ? raw.map(normalizeListRow) : []);
      setTotalRecord(res.response.responseMap?.totalCount ?? 0);
    });
  };

  const filterData = () => {
    setLoading(true);
    searchVendorRegistrationListData(searchData, page, rowsPerPage).then(
      (res) => {
        setLoading(false);
        const raw = res?.responseMap?.data ?? [];
        setData(Array.isArray(raw) ? raw.map(normalizeListRow) : []);
      },
    );
  };

    const handleExportVendorRegistration = () => {
      setLoading(true);
      const dateTime = (selectedVendorName || "Vendor Registration")
        .replace(/\s+/g, "_")
        .concat("_", moment(new Date()).format("DD_MM_YYYY_HH_mm_SS"));

        exportToExcelVendorRegistration(
          searchData.searchVendorCode || selectedVendorCode || "",
          selectedVendorName,
          dateTime,
          groupId,
          searchData.searchName,
          searchData.searchRegNo,
        ).then(() => {
          setLoading(false);
        });
      
    };

     const handleSAPExportVendorRegistration = () => {
      setLoading(true);
      const dateTime = (selectedVendorName || "Vendor Registration")
        .replace(/\s+/g, "_")
        .concat("_", moment(new Date()).format("DD_MM_YYYY_HH_mm_SS"));

        exportToExcelVendorRegistrationSAP(
          searchData.searchVendorCode || selectedVendorCode || "",
          selectedVendorName,
          dateTime,
          groupId,
          searchData.searchName,
          searchData.searchRegNo,
        ).then(() => {
          setLoading(false);
        });
      
    };


    

  return (
    <Fragment>
      {loading ? <CommonLoader /> : null}
      <Breadcrumb
        title="Vendor Registration"
        parent={
          <>
          {!isSAPAdmin && (
          <div className={classes.btnJust}>
            <Button
              color={"secondary"}
              variant="contained"
              type="button"
              className={`${classes.btnClass}`}
              startIcon={<Add></Add>}
              onClick={() =>
                history(
                  `${process.env.PUBLIC_URL}/master/vendorSendInvite`,
                )
              }
            >
              Add Send Invite
            </Button>
          </div>
          )}
          </>
        }
      />
      {/* <!-- Container-fluid starts--> */}
      <Container fluid={true}>
        <Row>
          <CommonAccordion accordionTitle={"Advanced Search"}>
            <Grid container columnSpacing={2} className={classes.muiGrid}>
              <Grid item sm={3} xs={12}>
                <TextField
                  fullWidth
                  label="Company Name"
                  size="small"
                  select
                  // InputLabelProps={{ shrink: true }}
                  name="searchName"
                  value={searchData.searchName}
                  onChange={onFilterInputChange}
                >
                  <MenuItem value="">
                    <em>Select Company Name</em>
                  </MenuItem>
                  {companyNameOptions.map((opt) => (
                    <MenuItem
                      key={opt.vendorCode + (opt.vendorName || "")}
                      value={opt.vendorName || ""}
                    >
                      {opt.vendorName || ""}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item sm={3} xs={12}>
                <TextField
                  fullWidth
                  label="Vendor Code"
                  size="small"
                  select
                  name="searchVendorCode"
                  value={searchData.searchVendorCode}
                  onChange={onFilterInputChange}
                >
                  <MenuItem value="">
                    <em>Select Vendor Code</em>
                  </MenuItem>
                  {vendorOptions.map((opt) => (
                    <MenuItem key={opt.vendorCode} value={opt.vendorCode}>
                      {opt.vendorCode} - {opt.vendorName}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item sm={3} xs={12}>
                <TextField
                  fullWidth
                  label="Reg No"
                  size="small"
                  name="searchRegNo"
                  value={searchData.searchRegNo}
                  onChange={onFilterInputChange}
                  placeholder="Enter Reg No"
                />
              </Grid>

              <Grid
                item
                sm={3}
                xs={12}
                sx={{
                  margin: "auto",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  color="primary"
                  variant="contained"
                  type="button"
                  className={classes.btnClass}
                  onClick={() => filterData()}
                >
                  <PersonSearch></PersonSearch>
                </Button>
                <Button
                  color="primary"
                  sx={{ marginLeft: 1 }}
                  variant="contained"
                  type="button"
                  className={classes.btnClass}
                  onClick={() => {
                    setSearchData(filterInitialValues);
                    loadListData();
                  }}
                >
                  <Refresh></Refresh>
                </Button>
                {!isSAPAdmin && (
                 <Button
                  color="primary"
                  sx={{ marginLeft: 1 }}
                  variant="contained"
                  type="button"
                  className={classes.btnClass}
                  onClick={() => {
                    handleExportVendorRegistration();
                  }}
                  
                >
               <FileCopy></FileCopy>
                </Button>
                )}

                  <Button
                  color="primary"
                  sx={{ marginLeft: 1 }}
                  variant="contained"
                  type="button"
                  className={classes.btnClass}
                  onClick={() => {
                    handleSAPExportVendorRegistration();
                  }}
                >
               SAP
                </Button>
                
              </Grid>
            </Grid>
          </CommonAccordion>
          <Card>
            <CardBody className={classes.cardbody}>
              <div>
                <CommonTableAp
                  tableData={data}
                  tableHeaders={vendorRegistrationListTableHeader}
                  tableColumns={vendorRegistrationListTableData}
                  editId={"vendorRegistrationListId"}
                  editMode={true}
                  readOnlyActionMode={isSAPAdmin}
                  onOpenModal={redirectToVendorRegistrationForm}
                  rowsPerPageOptions={[25, 50, 100]}
                  count={totalRecord}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  sx={{ float: "right" }}
                  showHistory={true}
                  showPdf={true}
                  from="Vendor Registration"
                  showPdfForRow={(row) =>
                    !!(row.vendorRegistrationListId ?? row.vendorRegistrationId)
                  }
                />
              </div>
            </CardBody>
          </Card>
        </Row>
      </Container>
      {/* <!-- Container-fluid Ends--> */}
      <ToastContainer autoClose={1000} />
    </Fragment>
  );
};

export default VendorRegistrationList;
